import React from 'react'

import Base from '../_Base'

const Reply = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M10.207 8c4.556 0 8.758 3.973 9.77 8.8-1.933-1.24-5.259-2.8-9.77-2.8h-1v1.586L4.621 11l4.586-4.586V8h1zm11.998 13.393L22.207 19c0-6.441-5.125-12.337-11-12.948V2.793a.5.5 0 0 0-.854-.354l-8.207 8.207a.502.502 0 0 0 0 .708l8.207 8.207a.5.5 0 0 0 .854-.354v-3.178c5.857.348 9.26 3.645 9.295 3.68l1.703 1.684z"
      fillRule="evenodd"
    />
  </Base>
)

export default Reply
